import { SrCustomerStatus } from '@plato/data/starrocks/types';
import { useTranslation } from 'react-i18next';
import { Badge, type BadgeProps } from './badge.tsx';

type CustomerStatusBadgeProps = {
    status: SrCustomerStatus;
};

export function CustomerStatusBadge({ status }: CustomerStatusBadgeProps) {
    const { t } = useTranslation();

    const statusConfig: Record<SrCustomerStatus, { label: string; color: BadgeProps['color'] }> = {
        [SrCustomerStatus.NEW]: {
            label: t('status_new', { ns: 'customers-list' }),
            color: 'blue',
        },
        [SrCustomerStatus.ACTIVE]: {
            label: t('status_active', { ns: 'customers-list' }),
            color: 'green',
        },
        [SrCustomerStatus.AT_RISK]: {
            label: t('status_at_risk', { ns: 'customers-list' }),
            color: 'orange',
        },
        [SrCustomerStatus.INACTIVE]: {
            label: t('status_inactive', { ns: 'customers-list' }),
            color: 'red',
        },
        [SrCustomerStatus.DORMANT]: {
            label: t('status_dormant', { ns: 'customers-list' }),
            color: 'red',
        },
        [SrCustomerStatus.BLOCKED]: {
            label: t('status_blocked', { ns: 'customers-list' }),
            color: 'red',
        },
    };

    const config = statusConfig[status];

    return (
        <div className="text-left">
            <Badge color={config.color} className="justify-start">
                {config.label}
            </Badge>
        </div>
    );
}
